
const renderQuestions = fields => {
  if (!fields) {
    return ''
  }

  let questions = ''
  for (const field of fields) {
    questions += `\t\t\t\tdata.${field.key} = '{${field.key}}';\n`;
  }
  return questions
}

export default function renderTwyneReward({ url, pubid, srcid, istest }, { extraFields }) {
  const questions = renderQuestions(extraFields)

  return `
    <div class="twyne-reward-header">
      <div class="reward-step-name">{reward_step_name}</div>
      <div id="reward-step-description" class="reward-step-description">you've selected <span id="reward-step-count" class="reward-step-badge">{offers_taken} of {offers_required}</span> offers nedded to earn <span class="reward-step-badge">{reward_step_points} points</span> and unlock this tier rewards!</div>
      <div id="reward-footer-text" class="reward-footer-text">Select <span id="reward-footer-count" class="reward-footer-count"></span> to complete this tier!</div>
      </div>
    <script type="text/javascript" src="${url}/assets/path.js"></script>
    <script type="text/javascript" id="twyne-embed" class="twyne-embed">
        (function (global) {
            function twyne_load() {
                var data = {};

                data.pid = '${pubid}';
                data.sid = '${srcid}';
                data.first = '{firstName_jsescape}';
                data.last = '{lastName_jsescape}';
                data.email = '{email_jsescape}';
                data.address1 = '{address1_jsescape}';
                data.address2 = '{address2_jsescape}';
                data.city = '{city_jsescape}';
                data.gender = '{gender_urlencoded}',
                data.state = '{state_urlencoded}';
                data.zip = '{zip_urlencoded}';
                data.country = 'US';
                data.phone = '{phone}';
                data.dob = '{dob_slashes_mmddyyyy_urlencoded}';
                data.istest = '${istest ? 'y' : 'n'}';
                data.externalgroup = '{pe_key}';
                data.subid1 = '{pid}';
                data.subid2 = '{sid1}';
                data.optout = '{optout}';
                data.checkers = '{checkers}';

                // return URL for when a user completes the path
                data.rurl = '{nextURL_urlencoded}';
                data.embedUrlOverride = '${url}';

                data.registration_trustedform = '{registration_trustedform}';
                data.registration_leadid = '{registration_leadid}';

${questions}

                global.twyne.initEmbed(data);
            }

            twyne_load();

            var plc = twyne.getPlacement("${pubid}${srcid}")

            var offersClicked = 0;
            var remainingOffers = {offers_required} - {offers_taken};
            var rewardStepFooterCount = document.getElementById('reward-footer-count');
            var rewardStepFooterText = document.getElementById('reward-footer-text');

            rewardStepFooterCount.textContent = remainingOffers > 1 ? remainingOffers + ' more offers' : remainingOffers + ' more offer'

            plc.on(Placement.events.offers.click, function (event) {
                var value = event.optinType;
                if (value) offersClicked++;

                if (offersClicked === remainingOffers) {
                  var userenrollNext = document.getElementsByClassName('userenroll-next')
                  for (var i = 0; i < userenrollNext.length; i++) {
                    var element = userenrollNext[i];
                    element.style.display = 'inline-block';
                  }
                }

                  var rewardStepDesc = document.getElementById('reward-step-description');
                  if ({offers_taken} + offersClicked >= remainingOffers) {
                    rewardStepDesc.innerHTML = "Congratulations! You have completed this tier and earned <span class='reward-step-badge'>{reward_step_points} points</span>"
                    rewardStepFooterText.innerHTML = "Click <a class='reward-continue-link' href='{nextURL}'>here</a> to continue."
                  } else {
                   rewardStepFooterCount.textContent = remainingOffers - offersClicked > 1 ? remainingOffers - offersClicked + ' more offers' : remainingOffers - offersClicked + ' more offer'
                   var rewardStepCount = document.getElementById('reward-step-count');
                   rewardStepCount.textContent = offersClicked + ' of ' + remainingOffers
                  }
            });
        })(this);
    </script>
    <style>
      .twyne-reward-header {
        padding: 40px 20px;
        text-align: center;
        color: #333;
        margin-bottom: 0;
        background: linear-gradient(135deg, #e9ecef, #dee2e6);
      }
      .reward-step-name {
        font-size: 44px;
        font-weight: bold;
        margin: 0 0 10px 0;
        color: #333;
      }
      .reward-step-description {
        font-size: 16px;
        color: #333;
        margin: 0;
        font-weight: 300;
      }
      .reward-step-badge {
        background: #f8f9fa;
        padding: 4px 12px;
        border-radius: 20px;
        font-weight: bold;
        margin: 0 2px;
        white-space: nowrap;
        color: #333;
      }
       .reward-footer-text {
         font-size: 16px;
         margin-top: 10px;
         color: #aaa;
         font-weight: 300;
       }
       .reward-footer-count {
         font-weight: bold;
       }
        .reward-continue-link {
          font-weight: bold;
          text-decoration: none;
          color: #aaa;
        }
        .reward-continue-link:hover {
          color: #aaa;
          text-decoration: underline;
        }
    </style>
    `.trim()
}
